import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, IconButton, Button } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { fetchBatchesByProductId } from "../../../../Reducer/productBatchesSlice";

import { StyledDrawer, HeaderBox } from "././BatchComponents/styled";
import BatchList from "././BatchComponents/BatchList";
import UploadModal from "././BatchComponents/UploadModal";

const BatchManagement = ({ isMobile, recordId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log("fetcing batch fro record id ", recordId)

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openUploadCsv, setOpenUploadCsv] = useState(null);

  const { data: batchesData, loading, error } = useSelector(
    (state) => state.productBatches
  );

  useEffect(() => {
    if (recordId) {
      dispatch(fetchBatchesByProductId(recordId));
    }
  }, [recordId, dispatch]);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setDrawerOpen(true)}
        startIcon={<EventIcon />}
        sx={{
          background: "#1976d2",
          borderRadius: "4px",
          textTransform: "none",
          fontWeight: "600",
        }}
      >
        Manage Batches
      </Button>

      <StyledDrawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: { width: isMobile ? "90%" : 450, display: "flex", flexDirection: "column" },
        }}
      >
        <HeaderBox>
          <Typography variant="h6" sx={{ fontWeight: "600" }}>
            Batch Management
          </Typography>
          <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </HeaderBox>

        <Box sx={{ p: 3, overflow: "auto", flexGrow: 1 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            Manage and monitor all your data batches in one place. Expand each
            batch to view detailed information.
          </Typography>

          <BatchList
            batches={batchesData}
            loading={loading}
            error={error}
            onUpload={setOpenUploadCsv}
          />
        </Box>

        <Box sx={{ p: 3, borderTop: "1px solid #eee", textAlign: "right" }}>
          <Button
            variant="contained"
            color="secondary"
            sx={{ background: "#1976d2", color: "#fff" }}
            onClick={() => {
              setDrawerOpen(false);
              navigate("/dashboard/allbatches");
            }}
          >
            All Batches
          </Button>
        </Box>
      </StyledDrawer>

      <UploadModal
        openUploadCsv={openUploadCsv}
        setOpenUploadCsv={setOpenUploadCsv}
        batches={batchesData}
      />
    </>
  );
};

export default BatchManagement;
